import { v4 as uuidv4 } from 'uuid'

export enum Status {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info'
}

export const SNACKBAR_TIMEOUT = 6000 //in ms

export interface IMessage {
  id: string
  type: Status
  message: string
  duration?: number
}

export function successMessage(message: string, id?: string, duration?: number): IMessage {
  return {
    id: id ?? uuidv4(),
    type: Status.SUCCESS,
    message,
    duration: duration ?? SNACKBAR_TIMEOUT
  }
}

export function infoMessage(message: string, id?: string, duration?: number): IMessage {
  return {
    id: id ?? uuidv4(),
    type: Status.INFO,
    message,
    duration: duration ?? SNACKBAR_TIMEOUT
  }
}

export function errorMessage(message: string, id?: string): IMessage {
  return {
    id: id ?? uuidv4(),
    type: Status.ERROR,
    message,
    duration: Infinity
  }
}
